var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{staticClass:"d-flex justify-content-center",attrs:{"fixed":"bottom","type":"dark","variant":"dark"}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"href":"https://www.ncl.ac.uk","target":"_blank"}},[_vm._v(" © "+_vm._s(_vm.currentYear)+" Newcastle University ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }